<template>
    <div class="container mt-3">

        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="updatePassword">
                            <div :class="'alert alert-'+(message.success ? 'success' : 'danger')" v-if="message.text">{{ message.text }}</div>
                            <div class="alert alert-warning" v-if="passwordsEqual">Пароли не совпадают</div>
                            <div class="alert alert-warning" v-if="newPasswordIsCurrent">Новый пароль не должен совпадать со старым</div>
                            <input type="text" name="email" :value="merchant.email" autocomplete="username email" style="display:none">
                            <div class="row">

                                <div class="col-md-4">
                                    <div class="form-group ">
                                        <label>Логин</label>
                                        <input type="text" class="form-control" :value="merchantAuthEmail" disabled readonly/>
                                    </div>

                                    <div class="form-group ">
                                        <label>Текущий пароль</label>
                                        <input type="password" class="form-control" placeholder="Введите текущий пароль" v-model="formData.oldPassword" autocomplete="current-password" />
                                    </div>

                                    <div class="form-group ">
                                        <label>Новый пароль</label>
                                        <input type="password" class="form-control" placeholder="Введите новый пароль" v-model="formData.newPassword" autocomplete="new-password" />
                                    </div>

                                    <div class="form-group ">
                                        <label>Повторите новый пароль</label>
                                        <input type="password" class="form-control" placeholder="Повторите новый пароль" v-model="formData.repeatPassword" autocomplete="new-password" />
                                    </div>

                                    <button class="btn btn-primary" :disabled="!isFormValid">Сохранить</button>
                                </div>
                            </div>
                        </form>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "SettingsAuth",
        mounted() {
            axios.get('/admin/merchant-auth-email')
                .then((response) => {
                    this.merchantAuthEmail = response.data;
                })
                .catch((error) => {
                    this.merchantAuthEmail = '';
                });
        },
        computed: {
            isFormValid() {
                return !this.loading && !this.dataEmpty && !this.passwordsEqual && !this.newPasswordIsCurrent
            },
            passwordsEqual() {
                return this.formData.repeatPassword !== '' && this.formData.newPassword !== this.formData.repeatPassword;
            },
            newPasswordIsCurrent() {
                return this.formData.newPassword === this.formData.oldPassword;
            },
            dataEmpty() {
                return this.formData.newPassword.length === 0 || this.formData.oldPassword.length === 0 || this.formData.repeatPassword.length === 0
            },
            ...mapState({
                merchant: state => state.merchant,
                loading: state => state.loading
            }),

        },
        data () {
            return {
                merchantAuthEmail: '',
                formData: {
                    oldPassword: '',
                    newPassword: '',
                    repeatPassword: '',
                },
                message: {
                    success: false,
                    text: ''
                }
            }
        },
        methods: {
            updatePassword() {
                this.$store.commit('setLoading');
                axios.post('/admin/merchant/password/update', {
                    new_password: this.formData.newPassword,
                    old_password: this.formData.oldPassword
                })
                    .then(response => {
                        this.message.success = response.data.success;
                        this.message.text = response.data.message
                    }).catch(error => {
                        this.message.success = error.response.data.success;
                        this.message.text = error.response.data.message
                    }).then(() => { this.$store.commit('unsetLoading'); })
            }
        }
    }
</script>

<style scoped>

</style>
